import React, { useCallback, useMemo, useState } from 'react'
import { TextInput, View } from 'react-native'
import { observer } from 'mobx-react'
import { usePlacesWidget } from 'react-google-autocomplete'
import { parseGmapAddress } from './parseGmapAddress'

const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY

const addressAutocompleteParams = {
  apiKey: GOOGLE_MAP_API_KEY,
  options: {
    types: ['geocode', 'establishment'],
    componentRestrictions: { country: 'us' },
  },
}

export const GmapAddressInput = observer(function GmapAddressInput ({ model, style }) {
  const setValue = model && model.setValue

  const onPlaceSelected = useCallback(place => {
    const { address_components } = place
    const address = parseGmapAddress(address_components)
    const { city, country, state, streetName, zipCode, streetNumber } = address
    if (setValue) {
      setValue('zip', zipCode)
      setValue('city', city)
      setValue('address', `${streetNumber} ${streetName}`)
      setValue('state', state)
    }
  }, [setValue])

  const cityAddress = `${model.address || ''} ${model.city || ''}`.trim()

  const defaultAddress = [cityAddress, model.state]
    .filter(value => typeof value === 'string')
    .map(value => value.trim()).filter(value => value.length > 0).join(', ')

  const AddressPicker = useCallback(function AddressPicker () {
    const [address, setAddress] = useState(defaultAddress)

    const { ref } = usePlacesWidget({ ...addressAutocompleteParams, onPlaceSelected })

    return useMemo(() => (
      <View style={style}>
        <TextInput autoFocus ref={ref} value={address} onChangeText={setAddress} placeholder="Type to search"
                   style={{ paddingHorizontal: 10, paddingVertical: 16 }}/>
      </View>
    ), [ref, address])
  }, [defaultAddress, onPlaceSelected])
  return useMemo(() => <AddressPicker/>, [AddressPicker])
})
